// extracted by mini-css-extract-plugin
module.exports = {"bigImageContainer":"bigImage_bigImageContainer__LTIMe"};